import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
};

export const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    addProducts: (state, action) => {
      const product = action.payload
      state.products = product
    },
    selectedCategory: (state, action) => {
      const filter = state.products.filter(product => product.categories.includes(action.payload))
      state.products = filter
    },
    selectedColor:(state, action) => {
      const filter = state.products.filter(product => product.color.includes(action.payload))
      state.products = filter
    },
    selectedBrand:(state, action) => {
      const filter = state.products.filter(product => product.brand.some(b => b === action.payload))
      state.products = filter
    }
  }

});

export const {
  addProducts,
  selectedCategory,
  selectedColor,
  selectedBrand,
} = filterSlice.actions;

export default filterSlice.reducer;
